<template>
  <div class="main common-table-cnt search">
    <el-form :inline="true" :model="formInline" class=" demo-form-inline">
      <el-form-item :label="$t('mechanism')">
        <el-select
          ref="paramOuSelect"
          v-model="formInline.ouName"
          style="width:auto"
          :placeholder="$t('peaseSelect')"
          :popper-append-to-body="false"
          @change="changeParamOu"
          clearable
          @visible-change="visibleChange"
        >
          <el-option :value="formInline.ouName" style="height:auto;padding:0px">
            <el-tree
              ref="paramOuTree"
              node-key="id"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              :data="ouList"
              :props="defaultProps"
              @node-click="selectParamOu"
            >
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('userNameH')" v-if="!userId">
        <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serialNumberP')">
        <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Recordtime')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeB"
          :placeholder="$t('startDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('TO')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeE"
          :placeholder="$t('endDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
        <el-button
          type="primary"
          class="serachBtn letter_delet"
          v-has="'sys:new:setting:log:data:delete'"
          v-if="activeName === 'consumePower'"
          @click="handleDelet"
          v-preventReClick="1000"
          >{{ $t('batchDelete') }}</el-button
        >
        <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{
          $t('exportButton')
        }}</el-button>
      </el-form-item>
    </el-form>
    <div class="common-blue-tabs view-info">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="$t('powerConsumptStatist')" name="endurance"></el-tab-pane>
        <el-tab-pane :label="$t('powerConsumptRecords')" name="consumePower"> </el-tab-pane>
      </el-tabs>
    </div>
    <div class="total-flow">
      <span v-if="activeName === 'consumePower'">
        {{ $t('sumBatteryVolume') }}(mAh)：
        <i class="log-num">{{ statisData.sum_of_volume }}</i>
      </span>
      <span v-if="activeName === 'consumePower'">
        {{ $t('avgBatteryVolume') }}(mAh)：
        <i class="log-num">{{ statisData.avg_of_volume }}</i>
      </span> 
      <span v-if="activeName === 'endurance'"
        >{{ $t('averageDailyUsage') }}(h)：<i class="log-num">{{ statisData.sum_average_day }}</i></span
      >
      <span v-if="activeName === 'endurance'"
        >{{ $t('averageDailyElectricity') }}(mAh)：<i class="log-num">{{ statisData.sum_average_elect }}</i></span
      >
    </div>
    <!-- table 组件 -->
    <Table
      v-loading="loading"
      :data="tableData"
      :columns="columns"
      :operation="dateOperation"
      :tableHeight="590"
      :type="type"
      :showSelcet="showSelcet"
      ref="tanleAssembly"
      @getList="getList"
      @operate="operationEvent"
      :currentPage="currentPage"
      :pageSize="pageSize"
      :operationWidth="100"
      @sortChange="handleSort"
    ></Table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>

<script>
// 引入table组件
import Table from '@/components/NewTable'
// 引入接口
import { getBatterys, deleteBatteryLog, batterysAppNames, batterysStatistics } from '@/api/log'
import { getOus } from '@/api/UserList'
import { getExportBatterys, batterysEndurance, batterysSstatistics } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  name: 'Battrey',
  props: {
    // 实时监控》历史记录》组件弹窗传用户名
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      // 表单查询字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        appName: '',
        searchTimeB: beforeWeekDate(),
        searchTimeE: nowDate(),
      },
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      appNames: [],
      // 电量数据
      statisData: {},
      // 用于批量删除 公共组件类型判断
      type: 'battery',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      // 当前选中tab active的name
      activeName: 'endurance',
      showSelcet: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    // 切换tab
    handleClick() {
      this.currentPage = 1
      this.pageSize = 10
      this.tableData = []
      this.formInline.sortColName = ''
      this.formInline.useAsc = null
      if (this.activeName === 'endurance') {
        this.enduranceConfig()
        this.basicConfig()
        this.formInline.type = 0
        this.showSelcet = false
      } else if (this.activeName === 'consumePower') {
        this.configInfo()
        this.basicConfig()
        this.formInline.type = 1
        this.showSelcet = true
      }
    },
    //导出列表
    exportList() {
      if (this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'), //提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
        type: this.formInline.type,
      }
      getExportBatterys(params).then(res => {
        let fileName = (this.formInline.type === 0 ? this.$t('powerConsumptStatist') : this.$t('powerConsumptRecords'))
        downloadBlobExcel(res, fileName + '.xls')
        this.exportLoading = false
      })
    },
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.delectBatteryLog(row)
      }
    },
    //  删除电量日志
    delectBatteryLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteBatteryLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.searchTimeB, this.formInline.searchTimeE)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        appName: this.formInline.appName,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      if (this.activeName === 'endurance') {
        this.getBatterysEndurance(param)
      } else if (this.activeName === 'consumePower') {
        this.getBatterysData(param)
      }
    },
    getBatterysData(param) {
      // 获取电量table数据
      getBatterys(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // 获取总数/平均数据
      batterysStatistics(param).then(res => {
        if (res.state === 0) {
          this.statisData = res.value
          this.statisData.avg_of_volume = res.value.avg_of_volume === null ? 0 : res.value.avg_of_volume
          this.statisData.sum_of_volume = res.value.sum_of_volume === null ? 0 : res.value.sum_of_volume
        }
      })
    },
    // 获取电池耗电量
    getBatterysEndurance(param) {
      batterysEndurance(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // 获取日均使用时长和日均耗电量
      batterysSstatistics(param).then(res => {
        if (res.state === 0) {
          this.statisData = res.value
          this.statisData.sum_average_day = res.value.avg_of_duration === null ? 0 : res.value.avg_of_duration
          this.statisData.sum_average_elect = res.value.avg_of_volume === null ? 0 : res.value.avg_of_volume
        }
      })
    },
    enduranceConfig() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'statisticsTime',
          label: this.$t('statisticalDate'),
          align: 'right',
          width: '140',
          sort: 'statisticsTime',
        },
        {
          attrName: 'usageDuration',
          label: this.$t('hoursOfUse')+'(h)',
          align: 'right',
          width: '150',
          sort: 'usageDuration',
        },
        {
          attrName: 'volume',
          label: this.$t('totalElectricity')+ '(mAh)',
          align: 'right',
          width: '240',
          sort: 'volume',
        },
        {
          attrName: 'records',
          label: this.$t('powerRecords'),
          align: 'left',
          rowBranch: true,
          sort: 'records',
        },
      ]
      this.type = ''
      // table 操作栏配置
      this.dateOperation = [
      ]
    },
    configInfo() {
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'volume',
          label: this.$t('batteryVolume'),
          align: 'right',
          width: '200',
          sort: 'volume',
        },
        {
          attrName: 'dumpEnergy',
          label: this.$t('batteryDumpEnergy'),
          align: 'right',
          width: '240',
          sort: 'dumpEnergy',
        },
        {
          attrName: 'temperature',
          label: this.$t('batteryTemperature'),
          align: 'right',
          width: '220',
          sort: 'temperature',
        },
        // {
        //   attrName: 'appName',
        //   label: this.$t('appName')
        // },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
        {
          attrName: 'uploadTimestamp',
          label: this.$t('uploadTimestamp'),
          align: 'center',
          width: '180',
          sort: 'uploadTimestamp',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 查询获取电池电量appNameList
    getAppNames() {
      batterysAppNames().then(res => {
        if (res.state === 0) {
          this.appNames = []
          for (let i = 0; i < res.value.length; i++) {
            this.appNames.push({ value: res.value[i], label: res.value[i] })
          }
        }
      })
    },
  },
  created() {
    this.handleClick()
    // this.basicConfig()
    // this.getAppNames()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.common-blue-tabs
  >>>.el-tabs__header
    margin 0
.demo-form-inline
  *zoom: 1
  &:before,&:after
    display: table
    content: ""
    clear: both
.total-flow {
  margin-bottom: 0px;
  line-height: 36px;
  background: #f0f9ff;
  border: 1px solid var(--border-grey);
  border-bottom: none;

  span {
    margin-left: 10px;
    font-weight: 600;

    &:first-child {
      margin-left: 20px;
    }
  }
}

.letter_delet {
  margin-left: 10px;
}

>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)

// 深色
.theme-dark {
  .total-flow {
    background: #072368;
    border: 1px solid #0057A8;
  }
}

.el-pagination .el-input .el-input__inner {
  height: 28px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
</style>
